/*
 * @Author: Zhouqi
 * @Date: 2022-03-24 10:51:43
 * @LastEditors: Zhouqi
 * @LastEditTime: 2022-04-08 14:23:25
 */
import axios from "../service/request";
// const baseUrl = "http://192.168.99.59:16000";
// const baseUrl = "http://192.168.4.43:16000";
import { BASE_URL } from "./httpHelper";

// 获取标记tag
export const getTagList = () => {
  return axios.get(BASE_URL + "/cms-pdrs/open/course/online/tag/list");
};

// 获取所有课程
export const getCourseList = (params: any = {}) => {
  return axios.get(BASE_URL + "/cms-pdrs/open/course/online/list", {
    params,
  });
};

// 获取课程详情
export const requestCourseDetail = (params: any = {}) => {
  return axios.get(BASE_URL + "/cms-pdrs/open/course/auth-if/online/detail", {
    params,
  });
};
